import { logError } from '../../helpers/logger';

import type { ContextFooterData } from '@web-platform/shared-universal-types/src/context';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

let footerData: Nullable<ContextFooterData> = null;

const setFooterData = (newFooterData: ContextFooterData): void => {
  footerData = newFooterData;
};

const getFooterData = () => {
  if (footerData === null) {
    const error = new Error('Footer Data is not set.');
    logError({
      error,
      component: 'GlobalFooter',
      message: 'Error getting footer data',
    });
  }
  return footerData;
};

export { getFooterData, setFooterData };
